import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { 
  FileText, 
  Check,
  ChevronRight
} from "lucide-react";

const PricingPage = () => {
  const speechFeatures = [
    "2 unikke udkast — vælg dit favorit eller mix det bedste fra begge",
    "Talenoter med pauser, tips og leveringshjælp",
    "Personlig tale baseret på dine anekdoter",
    "Gratis preview og tonevalg inden du betaler",
    "Ubegrænset redigering af den færdige tale",
    "Download som PDF i flot design",
    "100% tilfredshedsgaranti"
  ];

  return (
    <div className="min-h-screen bg-background py-8 md:py-16">
      <SEO
        title="Priser — Festtale fra 149 kr | MinFesttale.dk"
        description="Gennemsigtige priser uden skjulte gebyrer. Kort tale 149 kr, medium 249 kr, lang 299 kr. 2 udkast, ubegrænset redigering og 100% tilfredshedsgaranti."
        path="/priser"
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-primary">
            Priser
          </h1>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
            Gennemsigtige priser uden skjulte gebyrer. 
            Kvaliteten af en professionel skribent til en brøkdel af prisen.
          </p>
        </div>

        {/* Pricing Card */}
        <Card className="border-2 border-secondary" data-testid="pricing-tale">
          <CardContent className="p-0">
            <div className="p-6 border-b border-border/40 bg-secondary/5">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <FileText className="h-6 w-6 text-primary" />
              </div>
              <h2 className="font-heading text-2xl font-bold text-primary">
                Festtale
              </h2>
              <p className="text-muted-foreground mt-2">
                Personlig tale til bryllup, konfirmation, fødselsdag eller anden anledning
              </p>
            </div>
            
            <div className="p-6 space-y-4">
              <div className="flex justify-between items-center py-3 border-b border-border/40">
                <div>
                  <p className="font-medium text-primary text-lg">Kort tale (~2 min)</p>
                  <p className="text-sm text-muted-foreground">Ca. 400 ord</p>
                </div>
                <span className="font-bold text-2xl text-primary">149 kr</span>
              </div>
              <div className="flex justify-between items-center py-3 border-b border-border/40">
                <div>
                  <p className="font-medium text-primary text-lg">Medium tale (~4 min)</p>
                  <p className="text-sm text-muted-foreground">Ca. 800 ord · Mest populær</p>
                </div>
                <span className="font-bold text-2xl text-secondary">249 kr</span>
              </div>
              <div className="flex justify-between items-center py-3">
                <div>
                  <p className="font-medium text-primary text-lg">Lang tale (~6 min)</p>
                  <p className="text-sm text-muted-foreground">Ca. 1200 ord</p>
                </div>
                <span className="font-bold text-2xl text-primary">299 kr</span>
              </div>
            </div>

            <div className="p-6 pt-0">
              <h4 className="font-medium text-primary mb-3">Alt dette er inkluderet:</h4>
              <ul className="space-y-2 mb-6">
                {speechFeatures.map((feature, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-muted-foreground">
                    <Check className="h-4 w-4 text-accent flex-shrink-0 mt-0.5" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Link to="/tale">
                <Button className="w-full bg-secondary hover:bg-secondary/90 text-primary rounded-full py-6 text-lg" data-testid="pricing-tale-cta">
                  Start din tale nu <ChevronRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>

        {/* Comparison note */}
        <div className="mt-12 text-center bg-muted/30 rounded-xl p-8">
          <h3 className="font-heading text-xl font-bold text-primary mb-4">
            Sammenlign med alternativer
          </h3>
          <div className="grid md:grid-cols-2 gap-6 text-left max-w-2xl mx-auto">
            <div>
              <p className="font-medium text-primary">Professionel taleskriver</p>
              <p className="text-2xl font-bold text-muted-foreground">3.000-5.000 kr</p>
              <p className="text-sm text-muted-foreground">1-4 ugers leveringstid</p>
            </div>
            <div className="bg-secondary/10 p-4 rounded-lg -m-4 md:m-0">
              <p className="font-medium text-primary">MinFesttale</p>
              <p className="text-2xl font-bold text-secondary">Fra 149 kr</p>
              <p className="text-sm text-accent font-medium">Klar på 2 minutter!</p>
            </div>
          </div>
        </div>

        {/* Trust elements */}
        <div className="mt-8 text-center">
          <p className="text-muted-foreground">
            100% tilfredshedsgaranti · Se preview før du betaler · Sikker betaling via Stripe
          </p>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
